import React from "react"
import ReactDOM from "react-dom"
import "./index.scss"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import {ClientContext} from "graphql-hooks"
import config from "./config"
import {client} from "./gql/gqlInterceptor"

//sentry imports
import * as Sentry from "@sentry/browser"
import {CaptureConsole} from "@sentry/integrations"

Sentry.init({
  dsn: config.sentryDSN,
  integrations: [
    new CaptureConsole({
      levels: ["error", "warn"],
    }),
  ],
})

const Wrapped = (
  <ClientContext.Provider value={client}>
    <App />
  </ClientContext.Provider>
)

ReactDOM.render(Wrapped, document.getElementById("root"))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
